import { render } from "./CidJobTemplate.vue?vue&type=template&id=1b69bc2c&scoped=true"
import script from "./CidJobTemplate.vue?vue&type=script&lang=js"
export * from "./CidJobTemplate.vue?vue&type=script&lang=js"

import "./CidJobTemplate.vue?vue&type=style&index=0&id=1b69bc2c&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b69bc2c"]])

export default __exports__